import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

/** Figma-style instance glyph: a hollow diamond. */
export const InstanceIcon = React.memo(function InstanceIcon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 2.25L12.75 7.5L7.5 12.75L2.25 7.5L7.5 2.25Z"
        stroke={color}
        strokeLinejoin="round"
      />
    </svg>
  );
});
